<template>
    <FormLayoutRow>
        <div class="d-md-flex flex-fill align-items-sm-center w-md-50 align-self-start mt-3">
            <FormLayout class="gap-0">
                <FormLayoutRow>
                    <FormLayoutLabel>{{ $tm('station.latitude') }}</FormLayoutLabel>
                    <div class="d-flex flex-fill">
                        <InputNullableFloat
                            class="flex-fill"
                            v-model="station!.Latitude"
                        />
                    </div>
                </FormLayoutRow>

                <FormLayoutRow>
                    <FormLayoutLabel>{{ $tm('station.longitude') }}</FormLayoutLabel>
                    <div class="d-flex flex-fill">
                        <InputNullableFloat
                            class="flex-fill"
                            v-model="station!.Longitude"
                        />
                    </div>
                </FormLayoutRow>
            </FormLayout>
        </div>
        <div class="d-md-flex flex-fill align-items-sm-center w-md-50">
            <MapComp
                class="mt-5 me-5 w-100 border border-info"
                :tracks="[]"
                :centerpoint="centerPoint"
                :click-to-add-marker="true"
                :zoom="zoomLevel"
                :showCustomControls="false"
                :show-search-box="true"
                :showmaplabels="true"
                :hide-default-controls="true"
                :height="400"
                @map-clicked="onMapClicked"
            />
        </div>
    </FormLayoutRow>
</template>
<script lang="ts" setup>
import { InputNullableFloat, MapComp } from '@/components';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import { MapPoint, type StationDetails } from '@/objects/generated';
import { ref } from 'vue';

const station = defineModel<StationDetails>({ required: true });

const mappoint = ref<MapPoint>(MapPoint.FromJsValues({}));

const zoomLevel = ref<number>(10);

// We define the default mappoint. This is hardcoded to Oslo (59.9139, 10.7522) but should be depending on the Event
const defaultMappoint = MapPoint.FromJsValues({});
defaultMappoint.Latitude = 59.9139;
defaultMappoint.Longitude = 10.7522;

const centerPoint = ref<MapPoint>(defaultMappoint);

/**
 * Helper function to se if there is a position.
 * If the Longitude and Latitude is 0 we assume that there is no position
 */
const hasPosition = () => station.value != null && (station.value.Latitude ?? 0) != 0 && (station.value.Longitude ?? 0) != 0;

// If we have a position we set the mappoint to the position of the station
if (hasPosition()) {
    mappoint.value.Latitude = station.value.Latitude!;
    mappoint.value.Longitude = station.value.Longitude!;

    zoomLevel.value = 4;

    centerPoint.value = mappoint.value;
}

const onMapClicked = (point: MapPoint) => {
    station.value.Latitude = point.Latitude;
    station.value.Longitude = point.Longitude;
    mappoint.value = point;
};
</script>
